/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  width: "15",
  height: "3",
  viewBox: "0 0 15 3",
  fill: "currentColor",
  "aria-hidden": "true"
}, React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: "1.5",
  cy: "1.5",
  r: "1.5"
}), React.createElement("circle", {
  cx: "7.5",
  cy: "1.5",
  r: "1.5"
}), React.createElement("circle", {
  cx: "13.5",
  cy: "1.5",
  r: "1.5"
})));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "MeatballMenu";
Svg.element = element;
export default Svg;
